const sourceMapEndpoints = {
  list: () => '/source-maps' as const,
  detail: (id: number) => `/source-maps/${id}` as const,
  suggestions: () => '/source-maps/suggestions' as const
}

export default sourceMapEndpoints
